var exports = {
  "p": "list__vMdHel",
};

module.exports = exports;
